import { GeneralFunctions } from '../../helper'

describe('GeneralFunctions', () => {
  const { titalizeWord, capitalizeString, cleanNumberCurrency, trimString } = GeneralFunctions

  describe('#titalizeWord', () => {
    it('should return string', () => {
      const result = titalizeWord('hello')
      expect(result).toBe("Hello")
    })
  })

  describe('#capitalizeString', () => {
    it('should return string', () => {
      const result = capitalizeString('hello world')
      expect(result).toBe("Hello World")
    })
  })

  describe('#cleanNumberCurrency', () => {
    it('should return val', () => {
      expect(cleanNumberCurrency('$100,000')).toBe(100000)
    })
  })

  describe('#trimString', () => {
    it('should remove leading and trailing spaces', () => {
      expect(trimString(' hello ')).toBe('hello')
    })
  })

})
